import React from "react";

function PageNotFound() {
  return (
    <div className="flex items-top justify-center min-h-screen sm:items-center sm:pt-0">
      <div className="max-w-xl mx-auto sm:px-6 lg:px-8">
        <div className="flex items-center pt-8 sm:justify-start sm:pt-0">
          <div className="px-4 text-lg text-orange-500 border-r border-orange-400 tracking-wider">
            404
          </div>
          {/* eslint-disable-next-line @bigbinary/neeto/hard-coded-strings-should-be-localized */}
          <div className="ml-4 text-lg text-orange-500 uppercase tracking-wider">
            Not Found
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
